import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.QBooksCounterpartyCreationPopup.QBooksCounterpartyAddress',
    {
        cityTown: 'City/Town',
        cityTownPlaceholder: 'Enter City/Town',
        country: 'Country',
        countyPlaceholder: 'Enter country',
        countyStateProvincePlaceholder: 'Enter County/State/Province',
        county_state_province: 'County/State/Province',
        postalCode: 'Postcode',
        postalCodePlaceholder: 'Enter postcode',
        street: 'Enter address',
        streetAddressPlaceholder: 'Enter address',
    }
);
